/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {Entity} from '../../core/main.entity';
import {BlockAction} from './blockAction';
import {BlockElementLabel} from './blockElementContainer';
import {BlockElementType} from '../enums';
import {File} from '../file.entity';
import {BlockElement, BlockElementSettings} from './blockElement';

export class BlockElementArticle extends BlockElement {
  type: BlockElementType = 'article';

  @Type(() => BlockElementArticlePreview)
  preview?: BlockElementArticlePreview = null;

  @Type(() => BlockElementArticleSettings)
  settings?: BlockElementArticleSettings = new BlockElementArticleSettings();

  @Type(() => BlockAction)
  action?: BlockAction = null;
}

export class BlockElementArticlePreview extends Entity {
  title: string = null;
  text: string = null;

  @Type(() => File)
  image?: File = null;

  @Type(() => BlockElementLabel)
  label?: BlockElementLabel = null;
}

export class BlockElementArticleSettings extends BlockElementSettings {
}
